import { FC } from "react";
import {
    ArticleGrid,
    ArticleItem,
    ArticleItemText,
    Excerpt,
    Grid,
    Title,
    TitleBlue,
    TitleOrange,
    LinkedIn,
    Share,
    ShareSocialList,
    Square,
    Arrows,
    Arrow,
} from "../../components/blog";

const BlogPage: FC = () => {
    return (
        <Grid>
            <Square />
            <Title>
                <TitleBlue>Offsetted </TitleBlue>
                <TitleOrange>Blog</TitleOrange>
            </Title>
            <Arrows>
                <Arrow />
                <Arrow />
                <Arrow />
            </Arrows>
            <Excerpt>
                Discovering the most exciting topics on net zero transition together with climate
                experts, partners and customers. Dive in together with us to learn more about how to
                drive decarbonisation with technology
            </Excerpt>
            <Share>
                <ShareSocialList>
                    <LinkedIn
                        href='https://www.linkedin.com/shareArticle?url=https://offsetted.com/blog'
                        target='_blank'
                        rel='noopener noreferrer'
                    />
                </ShareSocialList>
            </Share>
            <ArticleGrid>
                <ArticleItem href='/oftd-finance' imagePath='/articles/bplt.svg'>
                    <ArticleItemText color='#082E99'>
                        Press release: Offsetted Finance launch at the Singapore Fintech Festival
                    </ArticleItemText>
                </ArticleItem>
                <ArticleItem href='/net-zero' imagePath='/articles/net-zero.svg'>
                    <ArticleItemText>
                        From offsetting to net-zero and reasons for sustainability
                    </ArticleItemText>
                </ArticleItem>
                <ArticleItem href='/decarbonization' imagePath='/articles/decarbonization/blog.svg'>
                    <ArticleItemText>
                        Decarbonization, sustainability and ESG. Why does the financial sector need
                        this?
                    </ArticleItemText>
                </ArticleItem>
            </ArticleGrid>
        </Grid>
    );
};

export default BlogPage;
